var map = {
	"./WhatsApp Image 2024-06-28 at 15.34.12 (1).jpeg": 7650,
	"./WhatsApp Image 2024-06-28 at 15.34.12 (2).jpeg": 5037,
	"./WhatsApp Image 2024-06-28 at 15.34.12.jpeg": 5096,
	"./WhatsApp Image 2024-06-28 at 15.34.13 (1).jpeg": 101,
	"./WhatsApp Image 2024-06-28 at 15.34.13 (2).jpeg": 2554,
	"./WhatsApp Image 2024-06-28 at 15.34.13 (3).jpeg": 3431,
	"./WhatsApp Image 2024-06-28 at 15.34.13.jpeg": 9695,
	"./alma_suite_bb_living_room.jpg": 1758,
	"./alma_suite_bb_outside.jpg": 9372,
	"./alma_suite_bb_outside_house.jpg": 2813,
	"./outside-new-1.jpeg": 802,
	"./outside-new-2.jpeg": 8319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4996;